import React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowUpRight } from "lucide-react";
export default function AssetClassSpotlight() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const metrics = [{
    label: "Capital Reach",
    value: "National"
  }, {
    label: "Asset Coverage",
    value: "Multi-Sector"
  }, {
    label: "Execution",
    value: "Institutional"
  }, {
    label: "Structure",
    value: "Flexible"
  }];
  return <section id="asset-class-spotlight" ref={sectionRef} className="dark bg-background text-foreground relative min-h-[85vh] flex flex-col justify-end overflow-hidden pb-16 pt-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/panoramic_skyline_dark.png)] bg-cover bg-center opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-black/60" />
        {}
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12">
        {}
        <div className={`mb-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Breadcrumb>
            <BreadcrumbList className="text-muted-foreground/60 sm:gap-2">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/" className="hover:text-white transition-colors uppercase tracking-widest text-[10px] sm:text-xs">
                    Home
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-muted-foreground/40" />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-white uppercase tracking-widest text-[10px] sm:text-xs font-medium">
                  Real Estate Capital
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          {}
          <div className="lg:col-span-8">
            <h1 className={`font-serif text-5xl md:text-7xl lg:text-8xl xl:text-9xl text-white leading-[0.9] tracking-tight mb-6 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              Real Estate <br />
              <span className="text-muted-foreground">Capital Mandate.</span>
            </h1>
            <p className={`text-muted-foreground max-w-xl text-lg md:text-xl font-light tracking-wide transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              Institutional-grade financing solutions structured for acquisition, development, and portfolio growth.
            </p>
          </div>

          {}
          <div className="lg:col-span-4 w-full">
            <div className={`grid grid-cols-2 gap-px bg-border/20 border border-border/20 transition-all duration-1000 delay-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {metrics.map((metric, i) => <div key={i} data-index={i} className="bg-background/40 backdrop-blur-sm p-6 flex flex-col gap-2 group hover:bg-background/60 transition-colors duration-500">
                  <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground/70">
                    {metric.label}
                  </span>
                  <span className="text-xl md:text-2xl font-serif text-white flex items-center justify-between">
                    {metric.value}
                    <ArrowUpRight className="w-4 h-4 text-muted-foreground/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border/30 to-transparent" />
    </section>;
}